import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { fetchEmployeeProductLists } from '../../../../../common/fetch.js';
import { EoeDeviceStoreHomeSceneCoCo } from '../../../../../components/EoeDeviceStoreHomeSceneCoCo/EoeDeviceStoreHomeSceneCoCo.js';
import { useAuth } from '../../../AuthProvider.js';
import type { EmployeeProductListResponse } from '../../../../../generated/api/employeeProductListResponse.js';

export const EoeStoreCoCo = () => {
  const navigate = useNavigate();
  const { authenticatedUser } = useAuth();
  const employeeMdmId = authenticatedUser?.mdmId;
  const [employeeProductLists, setEmployeeProductLists] = useState<EmployeeProductListResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoadError, setHasLoadError] = useState(false);

  useEffect(() => {
    if (!employeeMdmId) {
      setEmployeeProductLists([]);
      setIsLoading(false);
      setHasLoadError(false);
      return;
    }

    let isCurrentRequest = true;
    setEmployeeProductLists([]);
    setIsLoading(true);
    setHasLoadError(false);

    const loadEmployeeProductLists = async () => {
      try {
        const lists = await fetchEmployeeProductLists([employeeMdmId]);
        if (isCurrentRequest) {
          setEmployeeProductLists(lists);
        }
      } catch {
        if (isCurrentRequest) {
          setHasLoadError(true);
        }
      } finally {
        if (isCurrentRequest) {
          setIsLoading(false);
        }
      }
    };

    void loadEmployeeProductLists();

    return () => {
      isCurrentRequest = false;
    };
  }, [employeeMdmId]);

  return (
    <EoeDeviceStoreHomeSceneCoCo
      employeeProductLists={employeeProductLists}
      isLoading={isLoading}
      hasLoadError={hasLoadError}
      onSelectDeviceList={employeeProductList =>
        navigate(paths.EMPLOYEE_DEVICE_STORE_PHONES, { state: { employeeProductList } })
      }
    />
  );
};
